export const EXTRAITEMS_LOADING = 'REDUX_SAGA_EXTRAITEMS_LOADING';
export const GET_EXTRAITEMS_DATA_SUCCESS = 'REDUX_SAGA_GET_EXTRAITEMS_DATA_SUCCESS';
export const GET_EXTRAITEMS_DATA_ERROR = 'REDUX_SAGA_GET_EXTRAITEMS_DATA_ERROR';
export const GET_EXTRAITEM_OBJECT = "REDUX_SAGA_GET_EXTRAITEM_OBJECT";
export const GET_EXTRAITEM_OBJECT_AFTER_MEMBERSHIP = "REDUX_SAGA_GET_EXTRAITEM_OBJECT_AFTER_MEMBERSHIP";
export const UPDATE_PRODUCT_QUANTITY = "REDUX_SAGA_UPDATE_PRODUCT_QUANTITY";
export const RESET_EXTRAITEMS = "REDUX_SAGA_RESET_EXTRAITEMS";
export const RESET_ERROR_MSG = "REDUX_SAGA_RESET_ERROR_MSG";
export const SET_ADDTOCART = "REDUX_SAGA_SET_ADDTOCART"

export const actionGetExtraItems = (dispatch, ID, checkBookingTypeObj, isDisplayArea, nextTourDate,
    isListView, currentView, tourEventsList) => {
    dispatch({
        type: EXTRAITEMS_LOADING,
        payload: ID,
        checkBookingTypeObj: checkBookingTypeObj,
        isDisplayArea: isDisplayArea,
        nextTourDate: nextTourDate,
        isListView: isListView,
        currentView: currentView,
        tourEventsList: tourEventsList
    })
};

export const actionGetExtraItem = (dispatch, TourEventID, IsMembershipApplied, MemberCostRate, IsIDME, IsIDMECostRate, OrganizationCostRate) => {
    dispatch({
        type: GET_EXTRAITEM_OBJECT, payload: TourEventID, IsMembershipApplied: IsMembershipApplied, MemberCostRate: MemberCostRate, IsIDME: IsIDME, IsIDMECostRate: IsIDMECostRate
        , OrganizationCostRate: OrganizationCostRate
    })
};

export const actionGetExtraItemAfterMembership = (dispatch, TourData, TourEventID, IsMembershipApplied, MemberCostRate, IsIDME, IsIDMECostRate, OrganizationCostRate) => {
    dispatch({
        type: GET_EXTRAITEM_OBJECT_AFTER_MEMBERSHIP, payload: TourData, TourEventID: TourEventID, IsMembershipApplied: IsMembershipApplied, MemberCostRate: MemberCostRate,
        IsIDME: IsIDME, IsIDMECostRate: IsIDMECostRate, OrganizationCostRate: OrganizationCostRate

    })
};

export const actionIncreaseQuantity = (dispatch, productID, Quantity, ItemExist, MinimumTickets, MaximumTickets) => {
    dispatch({ type: UPDATE_PRODUCT_QUANTITY, payload: productID, Quantity: Quantity, ItemExist: ItemExist, MinimumTickets: MinimumTickets, MaximumTickets: MaximumTickets })
};

export const actionResetExtraItems = (dispatch) => {
    dispatch({ type: RESET_EXTRAITEMS })
};

export const actionResetErrorMessage = (dispatch) => {
    dispatch({ type: RESET_ERROR_MSG })
};

export const actionSetAddToCart = (dispatch) => {
    dispatch({ type: SET_ADDTOCART })
}